import * as menuActions from 'actions/menus';

const initialState = {
  fetchingMenuList: false,
  menuListFetched: false,
  menuList: [],
  fetchingMenu: false,
  menuFetched: false,
  updatingMenu: false,
  menuUpdated: false,
  selectedMenu: null,

  searchingMenu: false,
  menuSearchResults: [],
  fetchingOutOfStock: false,
  outOfStockItems: [],
  updatingStockStatus: false,
};

const menusReducer = (state = initialState, action) => {
  switch (action.type) {
    case menuActions.REQUEST_SEARCH_MENU:
      return { ...state, ...action.payload };
    case menuActions.SET_STOCK_UPDATED:
      return { ...state, ...action.payload };
    case menuActions.SET_MENU_SEARCH_RESULTS:
      return { ...state, ...action.payload };
    case menuActions.REQUEST_OUT_OF_STOCK_ITEMS:
      return { ...state, ...action.payload };
    case menuActions.SET_OUT_OF_STOCK_ITEMS:
      return { ...state, ...action.payload };
    case menuActions.REQUEST_SET_STOCK_STATUS:
      return { ...state, ...action.payload };
    case menuActions.REQUEST_MENU_LIST:
      return { ...state, ...action.payload };
    case menuActions.SET_MENU_LIST:
      return { ...state, ...action.payload };
    case menuActions.REQUEST_MENU:
      return { ...state, ...action.payload };
    case menuActions.SET_MENU:
      return { ...state, ...action.payload };
    case menuActions.REQUEST_UPDATE_MENU:
      return { ...state, ...action.payload };
    case menuActions.REQUEST_UPDATE_MENU_OPERATIONS:
      return { ...state, ...action.payload };
    case menuActions.UPDATED_MENU:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default menusReducer;



// WEBPACK FOOTER //
// ./src/reducers/menus/index.js